var color_id;
$(function () {
    $('.product-variants .colors .color').on('click', function () {
        color_id = $(this).data('color_id');
        let $firstSlideForColor = $('.slide-color-' + color_id).first();
        let index = $firstSlideForColor.closest('.slick-slide').data('slick-index');
        let slider = $('.product-slider');
        slider[0].slick.slickGoTo(index);
        setColor();
    });

    $('.product-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        let element = $(".product-slider .slide").eq(nextSlide);
        color_id = element.data('color-id');
        setColor();
    });

    $('.choose-size').on('change', function () {
        $('#variant-id').val($(this).val());
    });
    $('.color').first().trigger('click');

    if (($('.color').length) == 1) {
        setTimeout(function () {
            $('.color').first().trigger('click');
        }, 500);
    };
});

function setColor() {
    $('.choose-size').hide();
    $('.choose-size-color-'+color_id).show();

    $('.color').removeClass('active');
    $('#color-' + color_id).addClass('active');
    $('.option-size').hide();
    $('.color-' + color_id).show();
    //HACK
    if (($('.color').length) == 1) {
        $('.option-size').show();
    }
    $('.choose-size').prop("selectedIndex", 0);
}

